import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import ErrorView from 'scoreboard/components/error-view'

function showPartialError(err) {
	let options = _.defaults(err, {
		bypassMessageView: true
	})
	appDisplay.dialog(new ErrorView(options))
}

export default showPartialError

showPartialError.__filename__ = 'datasets/show-partial-error.js'
